import { Typography } from '@mui/material';
import React from 'react';
import CAppPaper from '../../../../app/components/CAppPaper';
import { useTranslation } from 'react-i18next';
import investmentKpiLang from '../../langs/investmentKpiLang';
import CAppInfoTooltip from '../../../../app/components/CAppInfoTooltip';
import AppFormatX from '../../../../app/features/format/AppFormatX';
import langInvestWordLang from '../../langs/langInvestWordLang';

type CTvpiProps = {
	value: number | null;
	isNS?: boolean;
};

const CTvpi = (props: CTvpiProps) => {
	const { value, isNS } = props;
	const { t } = useTranslation();
	return (
		<CAppPaper
			id="tvpi-component"
			variant="elevation"
			color="secondary"
			style={{
				padding: '30px 0px',
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				justifyContent: 'center',
			}}
		>
			<Typography variant="h2" component="h2" sx={{ textAlign: 'center', color: 'white', marginBottom: '0px' }}>
				{t(investmentKpiLang.tvpi.tag)}{' '}
				<CAppInfoTooltip title={t(investmentKpiLang.total_value_to_paid_in.tag)} />
			</Typography>
			<p
				style={{
					margin: '0px',
					fontFamily: "'Poppins'",
					fontStyle: 'normal',
					fontWeight: '700',
					fontSize: '2.5rem',
					lineHeight: '60px',
					textAlign: 'center',
					color: '#FFFFFF',
				}}
			>
				<AppFormatX value={value} isNS={isNS} textIfNull={t(langInvestWordLang.nc.tag)} />
			</p>
		</CAppPaper>
	);
};

export default CTvpi;
